module.exports = __webpack_public_path__ + "static/img/none-memo.7c9c4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/none-memo.png
// module id = QIsS
// module chunks = 2